/**
 * PSTUDIO-3393 / PSTUDIO-4122: pro-studio i18n keys carry a full `scope/file:`
 * prefix, because `packages/translations/src/i18n.ts` registers every app's
 * catalogue under one i18next instance — a bare `csv_import.toast.success` would
 * resolve against whichever namespace happened to be the default.
 *
 * Kept in one place because the string was already written out twice
 * (`draggable-row.tsx`, `node-behaviors-multi-select.tsx`) and a third copy was
 * about to be added: a typo in any one of them fails at RUN time, showing the key
 * to the user, and nothing in the build catches it.
 */
export const WORKFLOWS_NS = 'pro-studio/workflows';
